/** Home V2 首次引导支持的 Agent。 */
export type HomeV2OnboardingAgent = 'novelty-check-report' | 'fto-pro' | 'design-fto';

/** Home V2 Step 1 启动时的页面上下文。 */
export interface HomeV2EntryOnboardingStartOptions {
    /** 当前页面是否携带有效的 URL 预填问题。 */
    hasPrefilledInput: boolean;
}

/**
 * 编排 Home V2 Agent 介绍与各 Agent 原有输入引导的先后关系。
 */
export interface HomeV2EntryOnboardingService {
    /** 在页面子组件请求输入引导前同步设置 Step 1 上下文。 */
    setEntryContext(options: HomeV2EntryOnboardingStartOptions): void;
    /** 幂等启动当前 Agent 的 Step 1。 */
    start(
        agent: HomeV2OnboardingAgent,
        options?: HomeV2EntryOnboardingStartOptions,
    ): Promise<boolean>;
    /** 记录真实 Agent 切换并刷新 Step 1 文案。 */
    notifyAgentSwitched(fromAgent: HomeV2OnboardingAgent, toAgent: HomeV2OnboardingAgent): void;
    /** 等待 Step 1 结束，并向最终 Agent 发放一次输入引导许可。 */
    acquireInputGuide(agent: HomeV2OnboardingAgent): Promise<boolean>;
    /** 清理当前 Home V2 页面生命周期内的全部资源。 */
    destroy(): void;
}

/** Home V2 首次引导 service 的容器标识。 */
export const HomeV2EntryOnboardingService = Symbol('HomeV2EntryOnboardingService');
